exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#treeview[data-v-a3e97116] .v-treeview-node__label {\r\n  cursor: pointer;\n}\n#comments[data-v-a3e97116] .v-expansion-panel__container--active > .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {\r\n  -webkit-transform: rotate(0);\r\n          transform: rotate(0);\n}\niframe[data-v-a3e97116] {\r\n  position:absolute;\r\n    top:0;\r\n    left:0;\r\n    width:100%;\r\n    height:100%;\n}\r\n", ""]);

// exports
